
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-responsive";

export module DataTable {

	export async function initAllAsync(container: JQuery): Promise<void> {
		//$grid - breakpoints: (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px);


		var count = container.find(".table-data-table").length;

		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find(".table-data-table"), async (i, e) => {
				var table = new DataTable($(e));

				await table.initAsync();
				count -= 1;
				if (count == 0)
					resolve();
			});

			//container.find(".table-data-table").each(async function () {
			//	var table = new DataTable($(this));

			//	await table.initAsync();
			//	count -= 1;
			//	if (count == 0)
			//		resolve();
			//});

		});

	}

	export function SetOnChage(element: JQuery, callback: (source: JQuery) => void): void {
		var dataTable = <DataTable.DataTable>element.data("dataTable");
		if (dataTable)
			dataTable.onChange = callback;
	}

	export function fixFilter(element: JQuery, filterDiv: JQuery, filterButton: JQuery) {
		var dt = new DataTable(element);
		dt.fixFilter(filterDiv, filterButton);
	}

	export class DataTable {

		public wrapper: JQuery;
		private element: JQuery;
		private search: String;
		private pageIndex: Number;
		public dataTableObject: any;

		public onChange: (source: JQuery) => void = (source) => { };


		constructor(elem: JQuery) {
			this.element = elem;
		}

		public onQuickSearch(text: string): void {

		}

		public static getDataTable(elem: JQuery): DataTable {
			return elem.data("dataTable");
		}

		public async initAsync(): Promise<void> {

			var paging = this.element.data("paging");
			var sorting = this.element.data("sorting");
			var searching = this.element.data("searching");
			var emptyMessage = this.element.data("empty-message");

			var pageSize = isNaN(this.element.data("pageSize")) ? 10 : parseInt(this.element.data("pageSize"));

			this.element.find("th").each((i, e) => {
				if ($(e).find("button").length)
					$(e).addClass("no-sorting");
			});

			return new Promise<void>((notify, reject) => {

				var options = <any>{
					responsive: {
						details: {
							type: 'inline',
							target: 0
						},
						breakpoints: [
							{ name: 'xlarge', width: Infinity },
							{ name: 'desktop', width: 1200 },
							{ name: 'tablet-l', width: 1199 },
							{ name: 'tablet-p', width: 1199 },
							{ name: 'mobile-l', width: 768 },
							{ name: 'mobile-p', width: 320 }
						]
					},
					columnDefs: [
						{
							className: 'control',
							orderable: sorting,
							targets: 0
						},
						{
							targets: "no-sorting",
							orderable: false
						}
					],
					paging: paging,
					info: paging,
					searching: searching,
					ordering: sorting,
					pageLength: pageSize,
					pagingType: "full_numbers",
				};

				//if (emptyMessage != "") {
				//	if (!options.language)
				//		options.language = {};
				//	options.language.emptyTable = emptyMessage;
				//	options.language["sEmptyTable"] = emptyMessage;

				//}

				//Fix for a bug when sorting on columns
				(<any>options).aaSorting = [];


				if ($.fn.dataTable.isDataTable(this.element))
					this.element.DataTable().destroy();
				//var current = <DataTable>this.element.data("dataTable");
				//if (current && current.dataTableObject)
				//	current.dataTableObject.destroy();


				this.element.css("width", "100%");
				this.dataTableObject = this.element.DataTable(options);
				this.element.data("dataTable", this);


				this.dataTableObject
					.on("draw.dt", (e: JQueryEventObject, settings: any) => this.onDraw(e, settings))
					.on("search.dt", (e: JQueryEventObject, settings: any) => this.onSearch(e, settings))
					.on("page.dt", (e: JQueryEventObject, settings: any) => this.onPageChanged(e, settings))
					.on("responsive-display", (e: JQueryEventObject, settings: any) => this.onResponsiveResize(e, settings))

				this.wrapper = this.element.parents(".dataTables_wrapper");
				this.fix();

				notify();
			});


		}

		public reset(parameters: any): void {

			var dataTable = this.dataTableObject.search(parameters.search).page(parameters.pageIndex);
			//dataTable = dataTable.page.len(parameters.pageSize)

			this.wrapper.find(".row").eq(0).find("select").valSelect(parameters.pageSize);

			dataTable.draw("page");
		}


		private fix(): void {

			this.element.find("thead th:last-child").removeClass("sorting");


			this.wrapper.removeClass("form-inline");
			this.wrapper.find(".col-xs-12,.col-md-6,.col-md-5,col-md-7").removeClass("col-xs-12").removeClass("col-md-6").removeClass("col-md-5").removeClass("col-md-7").addClass("col");

			this.wrapper.find(".row").eq(0).addClass("align-items-center");
			var pageSizeCol = this.wrapper.find(".row").eq(0).find(".col").eq(0);
			pageSizeCol.find(".dataTables_length").addClass("w-100");

			var recordInfoRow = this.wrapper.find(".row").last();
			recordInfoRow.addClass("mt-h");
			recordInfoRow.find(".dataTables_info").addClass("w-100");

			var col = $("<div />").addClass("col text-left").css("font-size", "0.85em");
			pageSizeCol.children().appendTo(col);
			col.insertBefore(recordInfoRow.find(".col").eq(0).addClass("text-center"));


			this.wrapper.find(".dataTables_filter").css("float", "none").find("label").addClass("d-flex align-items-center").find("input").css("flex", 1);

			this.wrapper.find(".dataTables_info").addClass("text-muted").parents(".col-12").first().addClass("hidden-lg-down");
			this.wrapper.find(".dataTables_filter").find("input").attr("placeholder", "Search within results...");

			this.wrapper.find(".dataTables_paginate .pagination").addClass("pagination-sm").css("display", "block");
			this.wrapper.find(".dataTables_info.text-muted").addClass("font-sm");

			var tds = this.wrapper.find(".table td[data-width]");

			tds.each((i, elem) => {
				$(elem).css('max-width', $(elem).data('width'));
				$(elem).css('word-wrap', 'break-word');
			});

			var ths = this.wrapper.find(".table th[data-width]");

			ths.each((i, elem) => {
				$(elem).css('width', $(elem).data('width'));
				$(elem).css('word-wrap', 'break-word');
			});



			var searchTextElem: any = null;

			if ($(this.wrapper.find(".dataTables_filter label")).length > 0)
				$(this.wrapper.find(".dataTables_filter label")[0].childNodes).each(function (i, e: any) {
					if (e.nodeType == 3)
						searchTextElem = e;
				});

			$(searchTextElem).remove();


			var searching = this.wrapper.find(".table").data("searching");
			if (!searching)
				this.wrapper.find(".row").first().find(".col").eq(1).addClass("hidden");

			var paging = this.wrapper.find(".table").data("paging");
			if (!paging)
				this.wrapper.find(".row").first().find(".col").eq(0).addClass("hidden");


			var hasExcel = this.wrapper.find(".table").data("excel");
			if (hasExcel && !this.wrapper.data("excelAdded")) {
				this.wrapper.data("excelAdded", true);
				var excel = $("<button></button>").attr("type", "button").addClass("btn btn-sm btn-outline-success btn-solid-icon").attr("data-id", "buttonExcel");
				excel.append($("<i />").addClass("fa fa-file-excel")).append(" Excel");


				var cssClass = "";// this.wrapper.find(".dataTables_filter").find("input").length ? "col-4 col-sm-2" : "col-sm";

				var excelWrapper = $("<div></div>").addClass("text-right ml-sm-1 ml-xs-1" + cssClass).append(excel);
				excelWrapper.insertAfter(this.wrapper.find(".row").first().find(".col").eq(1));
				this.wrapper.find(".row").first().addClass("border-bottom border-2 pb-1");

			}

			this.wrapper.find(".dataTables_filter label").addClass("mb-0 pb-0");
			recordInfoRow.find(".col").eq(0).addClass("text-md-left");
			recordInfoRow.find(".col").removeClass("col").addClass("col-12 col-md text-sm-center text-xs-center");


			this.wrapper.find(".row").first().find(".col").eq(0).removeClass("hidden");



			var title = this.element.data("title") == undefined ? "" : this.element.data("title") + "";
			pageSizeCol.addClass("table-title h4").text(title);
			if (title.trim() == "")
				pageSizeCol.addClass("table-title h4");
			//if (pageSizeCol.parent().children().eq(1).hasClass("hidden"))
			//	pageSizeCol.parent().addClass("hidden");


			var maxCaptionWidth = 0;
			this.wrapper.find("ul.dtr-details li span:first-child").each((i, e) => {
				if ($(e).width() > maxCaptionWidth)
					maxCaptionWidth = $(e).width();
			});
			this.wrapper.find("ul.dtr-details li span:first-child").each((i, e) => {
				$(e).css("width", "calc(" + maxCaptionWidth + "px + 1em )");
			});


			//Add solid-icon style to the buttons
			this.wrapper.find("th button").addClass("btn-solid-icon");


			//Move filter as collapsible
			var component = this.element.closest(".component");
			var id = this.element.data("id");
			if (id != "") {
				var filter = component.find(".table-filter[data-filter-target='" + id + "']");
				if (filter.length) {
					var button = filter.siblings("button");
					if (!button.length)
						button = this.wrapper.find(".collapsible-toggle");
					this.fixFilter(filter, button);
				}
			}

			var quickSearch = this.wrapper.find(".table").data("quickSearch");
			if (!searching && quickSearch)
				this.renderQuickSearch();


			var messageContainer = this.wrapper.find(".dataTables_empty").eq(0);
			if (messageContainer.length) {
				var emptyMessage = this.element.data("empty-message");
				messageContainer.addClass("h4");
				if (emptyMessage != "")
					messageContainer.text(emptyMessage);
			}
		}


		public fixFilter(filterDiv: JQuery, filterButton: JQuery) {


			if ((filterDiv.length + filterButton.length < 2) || ((filterDiv.parent()[0].tagName.toLocaleLowerCase() != "body") && !filterDiv.is(":visible") && !filterButton.is(":visible"))) {
				filterButton.addClass("hidden");
				return;
			}

			this.wrapper = this.element.parents(".dataTables_wrapper");
			var component = this.element.closest(".component");
			var id = this.element.data("id");

			if (id != "") {
				filterDiv.removeClass("hidden").insertAfter(this.wrapper.find(".row").first());
				filterButton.removeClass("hidden").appendTo(this.wrapper.find(".row").first()/*.find(".col").last()*/);
				this.wrapper.find(".row").first().addClass("border-bottom border-2 pb-1");

			}
		}


		private renderQuickSearch() {

			var col = this.wrapper.find(".row").first().find(".col").eq(1);
			col.removeClass("hidden").html("");

			var placeholder = this.element.data("quick-search-placeholder");

			var input = $("<input type='text' />")
				.addClass("form-control datatable-quick-search")
				.attr("placeholder", placeholder)
				.prependTo(col);


			//Framework.BaseComponent.setOnEnterCallback(input, true, () => {
			//	if ($.isFunction(this.onQuickSearch))
			//		this.onQuickSearch(input.val());
			//});
		}


		private onResponsiveResize(e: JQueryEventObject, settings: any): void {
			if ($.isFunction(this.onChange))
				this.onChange(this.element);
			this.fix();
		}

		private onDraw(e: JQueryEventObject, settings: any): void {

			var filterDiv = this.wrapper.find(".table-filter");
			var filterButton = this.wrapper.find(".collapsible-toggle");
			if ($.isFunction(this.onChange))
				this.onChange(this.element);
			this.fix();
			this.fixFilter(filterDiv, filterButton);
		}

		private onSearch(e: JQueryEventObject, settings: any): void {
			this.search = (this.wrapper.find(".dataTables_filter input").val() || "").toString();
			this.element.data("search", this.search);
			this.fix();
		}

		private onPageChanged(e: JQueryEventObject, settings: any): void {

			var filterDiv = this.wrapper.find(".table-filter");
			var filterButton = this.wrapper.find(".collapsible-toggle");

			var info = this.dataTableObject.page.info();
			this.pageIndex = info.page;
			this.element.data("pageIndex", this.pageIndex);
			this.fix();

			this.fixFilter(filterDiv, filterButton);
		}
	}


	class DataTableOptions {

		constructor(init?: Partial<any>) {
			Object.assign(this, init);
		}

		autoWidth?: boolean = true;
		pageLength?: Number;
	}

}
